import * as tslib_1 from "tslib";
import { JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "@/API/Models/BaseResponse";
import { Profile } from "../Profile";
let ProfileResponse = class ProfileResponse extends BaseResponse {
    constructor() {
        super();
        this.profile = new Profile();
    }
};
tslib_1.__decorate([
    JsonProperty('Profile', Profile, true)
], ProfileResponse.prototype, "profile", void 0);
ProfileResponse = tslib_1.__decorate([
    JsonObject
], ProfileResponse);
export { ProfileResponse };
